import Phaser from 'phaser';
import SpritePool from '../../common/SpritePool';
import MouseTrailParticle from './MouseTrailParticle';

export default class MouseEmitter extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.maxParticles = 332;

    this.particlePool = new SpritePool(MouseTrailParticle, this.maxParticles, this);

    /** @type {MouseTrailParticle[]} */
    this.activeParticles = [];
  }

  makeParticle (x,y) {
    /** @type {MouseTrailParticle} */
    const particle = this.particlePool.getSprite();
    particle.reset();
    particle.x = x;
    particle.y = y;
    this.add(particle).bringToTop(particle.setVisible(true));
    this.activeParticles.push(particle);
  }

  resetParticle (i) {
    this.activeParticles[i].setVisible(false);
    this.particlePool.returnSprite(this.activeParticles[i]);
    this.activeParticles.splice(i,1);
  }

  tick () {
    const len = this.activeParticles.length - 1;
    for (let i = len; i >= 0; i--) {
      if (this.activeParticles[i].alpha <= 0) {
        this.resetParticle(i);
      }
      else {
        this.activeParticles[i].tick();
      }
    }
  }
}